export default __webpack_public_path__ + "static/media/shalwar.d0673259.png";